"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bestattungendunkerTheme = void 0;
exports.bestattungendunkerTheme = {
    logos: {
        memoresaLogoName: "logo_dark.png",
        memoresaLogotypeName: "logotype_dark.png",
        themeLogoName: ["bestattungendunker.png"],
    },
    // background: { main: '#eaeee9' },
    primary: {
        main: "#164b69",
        // contrast: '#fff',
    },
    secondary: {
        main: "#97be81",
        // contrast: '#d5e0d2',
    },
    navbar: {
        bg: "#eaeee9",
        color: "#164b69",
        hover: "#97be81",
    },
};
